import { HeaderBar } from "../components/header-bar";
import { FooterBar } from "../components/footer-bar";
import { ContentBox } from "../components/content-box";
import styles from "../app.module.scss";
import noparking from "../images/noparking.png";
import sophantering from "../images/sophantering.png";
import { Link } from "react-router-dom";

const KallaArstiden = () => {
  return (
    <>
      <h2>Den Kalla Årstiden</h2>

      <p>
        Det kan vara en bra motion att böja sig ned och plocka upp skräp eller
        att skotta undan lite snö. Om alla gör lite blir mycket gjort.
      </p>
    </>
  );
};

const Parkering = () => {
  return (
    <>
      <h2>Parkeringsregler på Daltorpsvägen</h2>
      <img src={noparking} alt="Parkering" className={styles.smallLeft} />

      <p>
        Gällande parkeringsregler på Daltorpsvägen. Sidan närmast oss har
        konstant parkeringsförbud, på andra sidan gäller att det alltid är
        parkering tillåten, utom tisdagar 8 – 16 under perioden 1 november till
        15 maj. För information om regler inom samfällighetens parkeringsplats
        finns information under <Link to="/ny-hos-oss">Ny hos oss?</Link>
      </p>
    </>
  );
};

const Sophantering = () => {
  return (
    <>
      <h2>Sophantering</h2>
      <img src={sophantering} alt="Sophantering" className={styles.smallLeft} />

      <p>
        Med vårt nya sätt att hantera sopor, så finns det några småsaker att
        tänka på.
      </p>

      <ul>
        <li>
          Förslut det emballage du packar soporna i så väl som möjligt och
          försök undvika att soporna hamnar utanpå locket eller på marken.
        </li>

        <li>
          Lämna under inga omständigheter sopor utanför behållarna. det finns
          ingen ursäkt för det.
        </li>

        <li>
          Det som kan återvinnas ska inte slängas i våra sopbehållare, ta med
          det till återvinningsplatser eller kör det till Lövsta.
        </li>
      </ul>
    </>
  );
};

const Skotsel = () => {
  return (
    <>
      <h2>Skötseln av Vårt Område</h2>

      <p>
        Skötseln av våra grönytor under sommarperioden har vi lagt ut på en
        extern leverantör.
      </p>

      <p>
        Under vintern är det viktigt att vi var och en håller ordning utanför
        vår egen tomt, så att det inte uppstår halka eller andra besvär när (om)
        det snöar.
      </p>
    </>
  );
};

export const PageInformation = () => {
  return (
    <>
      <HeaderBar />
      <ContentBox>
        <h1>Information</h1>

        <KallaArstiden />
        <Parkering />
        <Sophantering />
        <Skotsel />
      </ContentBox>
      <FooterBar />
    </>
  );
};
